<template>
    <div class="float-left mr-1">
        <span class="text-danger">
            <i
                class="fa fa-trash fa-lg icon-button"
                title="Excluir Documento"
                @click.stop="confirmarExcluirDocumento()"
            ></i>
        </span>
    </div>
</template>

<script>
import DocumentosServicos from './DocumentosServicos'
import { situacaoContrato } from '../SituacaoContrato'

export default {
    props: {
        documento: {
            type: Object,
            default: () => ({})
        },

        contrato: {
            type: Object,
            default: () => ({})
        },

        apostilamento: {
            type: Boolean,
            default: () => false
        }
    },

    data() {
        return {
            contratoApostilamento: null,
            labelJustificativa: '',
            textoInfoJustificativa: ''
        }
    },

    methods: {
        confirmarExcluirDocumento() {
            if (!this.contratoElaboracao() && !this.aditivarContrato()) {
                if (this.contratoApostilamento == null) {
                    this.$swal({
                        title: 'O que deseja fazer ?',
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Apostilar',
                        cancelButtonText: 'Atualizar'
                    }).then((result) => {
                        if (result.value) {
                            this.alternaJustificativa(
                                result.value == true ? 1 : 0
                            )
                            this.mostrarAlerta()
                        } else if (result.isDismissed) {
                            this.alternaJustificativa(
                                result.isConfirmed == true ? 1 : 0
                            )
                            this.mostrarAlerta()
                        }
                    })
                } else if (this.contratoApostilamento == 1) {
                    this.alternaJustificativa(this.contratoApostilamento)
                    this.mostrarAlerta()
                } else if (this.contratoApostilamento == 0) {
                    this.alternaJustificativa(this.contratoApostilamento)
                    this.mostrarAlerta()
                }
            } else {
                this.$swal({
                    title: 'Documento',
                    html: `Confirma a exclusão do documento ${this.documento.descricaoDocumento} do contrato <b>${this.contrato.vcCodigoEstruturado}</b>?`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim',
                    cancelButtonText: 'Não'
                }).then((result) => {
                    if (result.value) {
                        this.excluirDocumento()
                    }
                })
            }
        },

        mostrarAlerta() {
            this.$swal({
                title: 'Documento',
                html: `Confirma a exclusão do documento ${this.documento.descricaoDocumento} do contrato <b>${this.contrato.vcCodigoEstruturado}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não',
                input: 'textarea',
                inputPlaceholder: `Informe a ${this.labelJustificativa}`,
                inputValidator: (value) => {
                    if (!value) {
                        return `A justificativa ${this.textoInfoJustificativa} é obrigatória'`
                    }
                }
            }).then((result) => {
                if (result.value) {
                    this.excluirDocumento(result.value)
                }
            })
        },

        excluirDocumento(justificativa) {
            this.$store.dispatch('addRequest')
            let documentoDto = {
                documentoContratoId: this.documento.documentoContratoId,
                idContrato: this.$route.params.contratoId,
                justificativaApostilamento: justificativa,
                isApostilamento: this.contratoApostilamento == 1 ? true : false
            }
            DocumentosServicos.excluirDocumento(documentoDto).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.registroSalvoComSucesso(response.data)
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        registroSalvoComSucesso(data) {
            this.$toast.success(
                'Registro salvo com sucesso!',
                'OK',
                this.$toastConfig.success
            )
            this.$emit('obterDocumentosAtualizados')
        },

        situacoesVigenteDistribuido() {
            return (
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE2 ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_DISTRIBUIDO ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_DISTRIBUIDO
            )
        },

        contratoElaboracao() {
            return (
                this.$temAcessoView('CONT-ELAB-00') &&
                (this.contrato.idSituacaoContrato ==
                    situacaoContrato.PRE_CONTRATO_CONCLUIDO ||
                    this.contrato.idSituacaoContrato ==
                        situacaoContrato.CONTRATO_DISTRIBUIDO_AGUARDANDO_INTEGRACAO)
            )
        },

        aditivarContrato() {
            return (
                this.contrato.idSituacaoContrato == situacaoContrato.INICIADO_ADITIVO_CONTRATO
            )
        },

        atualizacaoContrato() {
            return (
                this.$temAcessoView('CONT-ATUALIZAR-00') &&
                this.situacoesVigenteDistribuido()
            )
        },

        alternaJustificativa(value) {
            this.contratoApostilamento = value
            if (this.contratoApostilamento == 1) {
                this.textoInfoJustificativa = 'do apostilamento'
                this.labelJustificativa = 'justificativa do apostilamento'
            } else {
                this.textoInfoJustificativa = ''
                this.labelJustificativa = 'justificativa'
            }
        },

        alternaJustificativaPorAcesso() {
            if (
                this.$temAcessoView('CONT-ATUALIZAR-00') &&
                this.$temAcessoView('CONT-APOST-07')
            ) {
                this.contratoApostilamento = null
            } else if (this.$temAcessoView('CONT-ATUALIZAR-00')) {
                this.contratoApostilamento = 0
                this.alternaJustificativa(this.contratoApostilamento)
            } else if (this.$temAcessoView('CONT-APOST-07')) {
                this.contratoApostilamento = 1
                this.alternaJustificativa(this.contratoApostilamento)
            }
        }
    },

    created() {
        this.alternaJustificativaPorAcesso()
    },

    computed: {},

    watch: {},

    validations: {}
}
</script>
